import axios from "axios";

export enum NotificationType {
  COMMENT = "COMMENT",
  TASK_REMINDER = "TASK_REMINDER",
  PROJECT_REMINDER = "PROJECT_REMINDER",
  CONTACT_DUPLICATES = "CONTACT_DUPLICATES",
  CURRENT_LOGINS = "CURRENT_LOGINS",
  INCOMING_CALL = "INCOMING_CALL",
  MISSING_CALL = "MISSING_CALL",
  CHECK_FLAME = "CHECK_FLAME",
  CHECK_PROJECT = "CHECK_PROJECT",
  TODO_FINISHED = "TODO_FINISHED",
  COMPLETE_TODO = "COMPLETE_TODO",
  INTERESTING_ENCOUNTER = "INTERESTING_ENCOUNTER"
}

export interface Notification {
  id: string;
  content: string;
  upstreamRef?: string;
  notificationType: NotificationType;
  createdUtc: Date;
  proxy: boolean;
}

interface NotificationApi {
  markedAsRead(notification: Notification): Promise<void>;
}

export const notificationApi: NotificationApi = {
  async markedAsRead(notification) {
    await axios.put(`/api/notifications/${notification.id}/_markedAsRead`);
  },
};
